<template>
  <div
    style="height: 100vh; display: flex; flex-direction: column"
    class="test_red"
  >
    <header>
      <MenuHeaderPublic />
    </header>
    <div class="header-spacer"></div>
    <!--    <div height="100vh">-->
    <main class="pt-16 home-partial-height">
      <v-container class="test_yellow container-home">
        <v-row no-gutters>
          <!--          <v-col v-if="$store.getters.appInfo.storeSearchRequired" cols="12">-->
          <!--            <PlaceAutocompleteNearStore />-->
          <!--          </v-col>-->
          <v-col v-if="$store.getters.appInfo.storeListRequired">
            <StoresListSection />
          </v-col>
        </v-row>
      </v-container>
      <MetaDataComponent
        v-if="metaTitle && metaDescription && metaKeywords"
        :title="metaTitle"
        :description="metaDescription"
        :keywords="metaKeywords"
      />
    </main>
    <!--    </div>-->
    <FooterComponent />
  </div>
</template>

<script>
/*
Actions:
  Meta name in the tab-translation
  Banner from API layout
  Search store status  from API layout
  Store list status  from API layout
  Delete store info
  Home status-redirect
*/
import MetaDataComponent from "@/components/metaDataComponent/MetaDataComponent.vue";
import FooterComponent from "@/views/front/home/components/FooterComponent.vue";
import backgroundImage from "@/assets/img/home/background.jpg";
import tiktokImage from "@/assets/img/home/tiktok.jpeg";

export default {
  layout: "Public",
  name: "Home",
  components: {
    MetaDataComponent,
    FooterComponent,
    StoresListSection: () => import("./components/StoresListSection.vue"),
  },
  computed: {
    banner: {
      get() {
        return this.$store.getters.appInfo
          ? this.$store.getters.appInfo.banner
          : backgroundImage;
      },
      set(val) {
        return val;
      },
    },
    appInfo: function () {
      return this.$store.getters.appInfo;
    },
    tiktok: {
      get() {
        return tiktokImage;
      },
    },
    metaTitle() {
      return this.$store.getters.appInfo.metaTitle;
    },
    metaDescription() {
      return this.$store.getters.appInfo.metaDescription;
    },
    metaKeywords() {
      return this.$store.getters.appInfo.metaKeywords;
    },
  },
  beforeMount() {
    if (!this.$store.getters.appInfo.requireHomePage) {
      this.$router.push({
        name: "Discovery",
        params: { id: this.$store.getters.appStoresList[0].slug },
      });
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.$store.dispatch("storeInfo/setStoreInfo", null);
      this.$appPageTitle.tab(this.$route.name);
    });
  },
  methods: {
    openSocialUrl(url) {
      window.open(url);
    },
  },
  // metaInfo() {
  //   return this.metaInfo;
  // },
};
</script>
<style lang="scss" scoped>
.container-home {
  max-width: 1400px !important;
  margin: 0 auto;
}

@media screen and (max-width: 960px) {
  .container-home {
    max-width: none;
    padding: 0 15px !important;
  }
}
@media screen and (max-width: 640px) {
  .footer {
    flex-direction: column-reverse !important;
    justify-content: center !important;
    align-items: center !important;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1400px) {
  .container-home {
    padding: 0 30px !important;
  }
}
.footer {
  background-color: #ffffff;
  height: 20vh;
  display: flex;
  flex-direction: row;
  border-top: 1px solid #c9c5c5;
  justify-content: center;
  align-items: center;
}
.separator {
  height: 1px;
  background-color: #c9c5c5;
  margin-bottom: 20px;
}

.content-x {
  display: flex !important;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  align-items: center;
}

.social-icons {
  //right: 20px;
  //margin-right: 25px;
  //position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.left-links {
  //left: 20px;
  ////margin-right: 25px;
  //position: absolute;
}

.social-icon {
  display: inline-block;
  font-size: 20px;
  color: #333;
}

.social-icon:hover {
  color: #007bff;
}

.header-spacer {
  height: 16px;
}
.home-partial-height {
  flex: 1;
}
</style>
